// Сессия Mini App (tech/08 §3): access, refresh и sessionKey — только в памяти. После перезапуска входим
// заново по свежему initData. Refresh — один на всех (одновременные 401 ждут одного запроса).
import type { ResponseOf, Api } from '@garages/contract';
import { ApiCallError, type ApiCall, type Session } from './api-client.js';

type AuthResponse = ResponseOf<Api['authTelegram']>;

export class SessionStore {
  private tokens: (Session & { refreshToken: string }) | null = null;
  private refreshing: Promise<boolean> | null = null;
  /** Обновление не удалось: сессию нельзя восстановить без нового входа. */
  onLost: (code: string) => void = () => {};

  current = (): Session | null => this.tokens;

  set(t: { accessToken: string; sessionKey: string; refreshToken: string }): void {
    this.tokens = { accessToken: t.accessToken, sessionKey: t.sessionKey, refreshToken: t.refreshToken };
  }

  clear(): void { this.tokens = null; }

  /** Вызов refresh для api-client; `call` передаётся позже, чтобы не было круговой зависимости. */
  refresh = (call: ApiCall) => async (): Promise<boolean> => {
    if (!this.tokens) return false;
    if (!this.refreshing) {
      const rt = this.tokens.refreshToken;
      this.refreshing = call('authRefresh', { body: { refreshToken: rt }, noRetry: true })
        .then((p) => { this.set(p); return true; })
        .catch((e: unknown) => {
          const code = e instanceof ApiCallError ? e.code : 'NETWORK';
          // обрыв сети — не потеря сессии: запрос упадёт своей ошибкой и повторится позже
          if (code !== 'NETWORK' && code !== 'TIMEOUT') { this.clear(); this.onLost(code); }
          return false;
        })
        .finally(() => { this.refreshing = null; });
    }
    return this.refreshing;
  };
}

export async function login(call: ApiCall, store: SessionStore, initData: string, device: { platform: string; tgVersion: string }): Promise<AuthResponse> {
  const r = await call('authTelegram', { body: { initData, device } });
  store.set(r);
  return r;
}
